import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "tabbar" }
const _hoisted_2 = { class: "tab-item flex-column-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "tab-item flex-column-center" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]

import { ClickAction } from '@/data/report'
import useAlert from '@/hooks/use-alert'
import useSelect from '@/hooks/use-select'
import {
  useLayoutStore,
  useConfAndQueryStore,
  namedImages,
  useCameraFrameStore
} from '@/store'
import { debounce, delay } from '@/utils'
import { storeToRefs } from 'pinia'
import { computed, ref, watch } from 'vue'

// eslint-disable-next-line no-undef

export default /*@__PURE__*/_defineComponent({
  __name: 'Footer',
  props: {
  isLoading: Boolean,
  ready: Boolean
},
  setup(__props) {

const props = __props

const cameraFrameStore = useCameraFrameStore()
const { isDefaultCameraActive } = storeToRefs(cameraFrameStore)
const layoutStore = useLayoutStore()
const {
  isAllWorksReady,
  isSnapshotLayerVisible,
  isShownByClosingSnapLayer,
  materialFilterVisibility
} = storeToRefs(layoutStore)
const { hasAlertShown } = useAlert()
const { reset } = useSelect()
const { report } = useConfAndQueryStore()

const isJustAfterReady = ref(false)
const visibility = computed<
  'loading' | 'snapshotting' | 'closing-snap-layer' | 'hidden' | 'visible'
>(() => {
  if (hasAlertShown.value) return 'hidden'
  if (props.isLoading) return 'loading'
  if (isSnapshotLayerVisible.value) return 'snapshotting'
  if (isShownByClosingSnapLayer.value) return 'closing-snap-layer'
  return 'visible'
})

const isNewWorks = computed(() => props.ready && !isAllWorksReady.value)
const isDecorationEnter = computed(
  () => isNewWorks.value || isDefaultCameraActive.value
)

const onTabClick = debounce(async (isAll: boolean) => {
  if (isAll) {
    report(ClickAction.TAB_ALLWORKS)
    layoutStore.gotoAllWorks(false)
    await delay(400)
    reset()
  } else {
    report(ClickAction.TAB_NEWWORKS)
    layoutStore.gotoNewWorks()
  }
})

watch(
  () => props.ready,
  async ready => {
    if (ready) {
      isJustAfterReady.value = true
      await delay(500)
      isJustAfterReady.value = false
    }
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["layout-footer", [`filter-${_unref(materialFilterVisibility)}`, visibility.value]])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([
        'layout-footer_inner',
        'lh-14',
        'PingFangSC-Regular',
        'font-10',
        __props.ready && !isDecorationEnter.value ? 'top-line' : undefined,
        isJustAfterReady.value ? 'after-ready' : undefined
      ])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(["tab-item_inner", !_unref(isAllWorksReady) && 'active']),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(onTabClick)(false)))
          }, [
            (!_unref(isAllWorksReady))
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _unref(namedImages).icon_home_dark
                }, null, 8, _hoisted_3))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: _unref(namedImages).icon_home_light
                }, null, 8, _hoisted_4)),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "tab-item_label" }, [
              _createElementVNode("span", null, "精选作品")
            ], -1))
          ], 2)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass(["tab-item_inner", _unref(isAllWorksReady) && 'active']),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(onTabClick)(true)))
          }, [
            (!_unref(isAllWorksReady))
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _unref(namedImages).icon_try_on_light
                }, null, 8, _hoisted_6))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: _unref(namedImages).icon_try_on_dark
                }, null, 8, _hoisted_7)),
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "tab-item_label" }, [
              _createElementVNode("span", null, "所有作品")
            ], -1))
          ], 2)
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["tab-decoration tab-decoration-left", {
          active: isDecorationEnter.value
        }])
      }, _cache[4] || (_cache[4] = [
        _createElementVNode("div", { class: "tab-decoration_inner" }, null, -1)
      ]), 2),
      _createElementVNode("div", {
        class: _normalizeClass(["tab-decoration tab-decoration-right", {
          active: isDecorationEnter.value
        }])
      }, _cache[5] || (_cache[5] = [
        _createElementVNode("div", { class: "tab-decoration_inner" }, null, -1)
      ]), 2)
    ], 2)
  ], 2))
}
}

})